export enum EProductType {
  ALL = "A",
  FINISH_PRODUCT = "F",
  MATERIAL = "M",
  PACKAGING = "P",
  SALE_OFF = "K",
}
